module.exports = __webpack_public_path__ + "img/ic_logo_maomao_o@2x.986c6629.png";